import { render, staticRenderFns } from "./EditUnilevelBonusSetting.vue?vue&type=template&id=5d9de7d4"
import script from "./EditUnilevelBonusSetting.vue?vue&type=script&lang=js"
export * from "./EditUnilevelBonusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports